import React, { useState } from 'react';
import {
  Card,
  CardHeader,
  CardContent,
  Typography,
  List,
  ListItem,
  Divider,
  Button,
  Box,
} from '@mui/material';
import { format } from 'date-fns';

export default function MemberMatchHistoryCard({ matches = [] }) {
  const [expanded, setExpanded] = useState(false);

  const toggleExpanded = () => {
    setExpanded((prev) => !prev);
  };

  if (!matches.length) {
    return (
      <Card sx={{ margin: 2, padding: 2 }}>
        <CardHeader title="Past Matches" />
        <CardContent>
          <Typography
            variant="body1"
            color="textSecondary"
            sx={{ textAlign: 'center', marginY: 2 }}
          >
            No match history yet.
          </Typography>
        </CardContent>
      </Card>
    );
  }

  const displayedMatches = expanded ? matches : matches.slice(0, 2);

  return (
    <Card sx={{ margin: 2, padding: 2 }}>
      <CardHeader title="Past Matches" />
      <CardContent>
        <List>
          {displayedMatches.map((match, index) => {
            const matchDate = match.matchDate?.toDate
            ? format(match.matchDate.toDate(), 'dd/MM/yyyy')
              : 'Unknown Date';

            return (
              <React.Fragment key={match.id}>
                <ListItem
                  sx={{
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    paddingY: 2,
                  }}
                >
                  <Typography variant="body2" color="textSecondary">
                    {matchDate}
                  </Typography>
                  <Typography variant="h6" color="primary">
                    {match.sportType} {match.pennantName} (Section {match.section})
                  </Typography>
                  
                  <Typography variant="body2" color="textSecondary">
                    {match.team1?.name || 'Unknown'} - {match.team1?.matchPoints} points
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    VS
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    {match.team2?.name || 'Unknown'} - {match.team2?.matchPoints} points
                  </Typography>
                </ListItem>
                {index < displayedMatches.length - 1 && <Divider />}
              </React.Fragment>
            );
          })}
        </List>
        {matches.length > 2 && (
          <Box sx={{ textAlign: 'center', marginTop: 2 }}>
            <Button onClick={toggleExpanded}>
              {expanded ? 'Show Less' : 'Show More'}
            </Button>
          </Box>
        )}
      </CardContent>
    </Card>
  );
}
